import { useRef } from 'react';
import { useGSAP } from '@gsap/react';
import { useInView } from 'framer-motion';
import gsap from 'gsap';

import { Background } from './Background';
import DashboardUI from './DashboardUi';
import { GoogleAds } from './GoogleAds';
import { Headshot } from './Headshot';
import { Options } from './Options';
import { Regulated } from './Regulated';

gsap.registerPlugin(useGSAP);

export function DesktopAnimation() {
  const containerRef = useRef<HTMLElement>(null);
  const dashboardRef = useRef<HTMLDivElement>(null);
  const isInView = useInView(containerRef, { once: true, amount: 0.3 });

  useGSAP(
    () => {
      if (!containerRef.current || !dashboardRef.current) return;

      // Set initial state for dashboard
      gsap.set(dashboardRef.current, { y: '100%' });
      // Animate dashboard
      gsap.to(dashboardRef.current, {
        y: '0%',
        duration: 0.9,
        delay: 0.3,
      });
    },
    { dependencies: [containerRef.current, dashboardRef.current] },
  );

  return (
    <section ref={containerRef} className="overflow-hidden rounded-16 relative">
      <div className="relative z-3">
        <Headshot
          name="Sherry J."
          title="Privacy"
          headshotUrl="https://cdn.sanity.io/images/ztw74qc4/production/6b1e9dfb4eed56d70799e357ee3f518583b883df-432x431.png"
          className="absolute m:top-180 l:top-60 top-[38%] left-[72%] m:left-250 l:left-[10%] xl:left-[16%] z-20"
          shouldAnimate={isInView}
        />
        <Headshot
          name="Zahir M."
          title="Marketing"
          headshotUrl="https://cdn.sanity.io/images/ztw74qc4/production/17f7fff3aabddb7fd6e021138b479aed589edf29-432x431.png"
          className="absolute m:bottom-60 bottom-[50%] right-[67%] m:right-[12%] z-20"
          shouldAnimate={isInView}
          additionalMobileDelay={0.15}
        />
        <GoogleAds shouldAnimate={isInView} className="m:left-18 m:bottom-30" />
        <Regulated shouldAnimate={isInView} />
        <Options shouldAnimate={isInView} />
        <div className="m:h-[300px] h-[85vw] w-[100vw] m:w-1" />
        <div
          ref={dashboardRef}
          className="rounded-t-30 overflow-hidden bottom-0 w-[90%] xl:w-[80%] mx-auto z-2 relative hidden m:block"
        >
          <DashboardUI className="mx-auto w-[100%] w-[" />
        </div>
      </div>
      <Background className="absolute -bottom-10 -right-10 -left-10 -top-10 z-1 w-[110%] h-[110%]" />
    </section>
  );
}
